<template>
<standard-dialog v-model="visible" scrollable persistent>

  <template slot="title">
    <span class="title">{{$t('face.face_setting')}}</span class="title">
  </template>

  <v-text-field box v-model="editFaceNameText" :label="$t('face.face_name')"></v-text-field>

  <scene-selector v-model="editFaceScene" :label="$t('face.scenes_to_trigger')" clearable></scene-selector>

  <template slot="actions">
    <v-btn color="red" flat @click="remove" :loading="removing">{{ $t('camera.delete') }}</v-btn>
    <v-spacer></v-spacer>
    <v-btn color="primary" flat @click="save">{{ $t('camera.save') }}</v-btn>
  </template>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'
import SceneSelector from '@/components/scene/SceneSelector'

export default {
  name: 'FaceLabelingEditDialog',
  mixins: [UserAuth],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    face: {
      type: Object,
      required: true
    }
  },
  components: {
    'standard-dialog': Dialog,
    'scene-selector': SceneSelector
  },
  data() {
    return {
      editFaceNameText: null,
      editFaceScene: null,
      removing: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    save() {
      let data = {
        Name: this.editFaceNameText,
        Scene: this.editFaceScene || ''
      };
      this.$db.ref('userFace').child(this.userId).child(this.face.FaceId).update(data)
        .then(() => this.visible = false)
        .catch(err => console.log(err.message));
    },
    async remove(f) {
      this.removing = true;
      let refFace = this.$db.ref('userFace').child(this.userId).child(this.face.FaceId);
      refFace.on('child_removed', snapshot => {
        refFace.off();
        this.visible = false;
      });
      let ref = this.$db.ref('command/face').push();
      try {
        await ref.set({
          user: this.userId,
          faceId: this.face.FaceId,
          cmd: 'remove'
        });
      } catch (err) {
        this.$emit('toast', this.$t('face.permission_denied'));
        this.removing = false;
        return;
      }

      let refErr = ref.child('error');
      refErr.on('value', snapshot => {
        let val = snapshot.val();
        if (val) {
          ref.remove();
          this.$emit('toast', val);
          this.removing = false;
        }
      });

      setTimeout(() => {
        refErr.off();
      }, 5000);
    }
  },
  mounted() {
    this.editFaceNameText = this.face.Name;
    this.editFaceScene = this.face.Scene;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cast/FaceLabelingEditDialog.vue